import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'PERMISSIONS_FORM', {
  TITLE: 'Permissions',
  NAME: 'Name',
  GUARD_NAME: 'Guard name',
  SUBMIT_BUTTON: 'Save',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'PERMISSIONS_FORM', {
  TITLE: 'Permisos',
  NAME: 'Nombre',
  GUARD_NAME: 'Nombre de la guardia',
  SUBMIT_BUTTON: 'Guardar',
  LOADING: 'Cargando...',
});
